import { BreadcrumbItemType } from '@/types/breadcrumb-item.type';

{
  /* 공통타입 */
}

export interface LabelValuePair {
  label: string;
  value: string;
}

export interface TagFilterProps<T extends LabelValuePair = LabelValuePair> {
  triggerPlaceholder?: string;
  selected: T[];
  list: T[];
  onFilterChange: (filter: T) => void;
  triggerAddClass?: string;
  itemAddClass?: string;
}

// TagFilterProps를 확장한 모든 타입을 허용
export type AnyTagFilterProps<T extends LabelValuePair = LabelValuePair> =
  TagFilterProps<T> & Record<string, unknown>;

export enum FormElementType {
  Text = 'text',
  Textarea = 'textarea',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Select = 'select',
}

export interface MenuItem extends BreadcrumbItemType {
  parentHref?: string;
  submenu?: MenuItem[];
}

export interface ImageEntity {
  imgUrl: string;
  label: string;
}

export enum SiteCategory {
  LICENSE = 'license',
  TRAINING = 'training',
}
